<template>
  <AlertGroup />
  <Category v-if="isAuthenticated" @setAuthentication="storeTokens" @removeAuthentication="removeTokens" />
  <Login v-else @setAuthentication="storeTokens" />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Category from '@/Category';
import Login from '@/Login';
import AlertGroup from '@/components/AlertGroup.vue';

const isAuthenticated = ref(false);

onMounted(() => {
  isAuthenticated.value = document?.cookie
    ?.split('; ')
    ?.filter(row => row.startsWith('access'))[0]
    ?.split('=')[1]
    ? true
    : false;
});

const removeTokens = () => {
  isAuthenticated.value = false;
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('categoryIndex');
  document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
};

const storeTokens = data => {
  document.cookie = `access_token=${data.token_type} ${data.access_token}; max-age=${data.expires_in}; path=/`;
  localStorage.setItem('refreshToken', data.refresh_token);
  isAuthenticated.value = true;
};
</script>

<style lang="postcss">
@import url('https://fonts.googleapis.com/css2?family=Cairo&display=swap');

html {
  height: 100%;
}

body {
  min-height: 100%;
}
* {
  direction: rtl;
  font-family: 'Cairo';
}

.date::before {
  content: ' ';
  float: right;
  background: url('assets/min/time.svg') center no-repeat;
  padding: 15px 10px;
  margin-left: 5px;
}

.number::before {
  content: '#';
}

button:hover {
  background: theme('colors.green.650');
}

button:active {
  background: theme('colors.green.650');
  box-shadow: none;
}

button:disabled {
  background: gray;
  cursor: not-allowed;
  @apply shadow-xl;
}

button:disabled div {
  color: gray;
}

button:disabled:active {
  background: gray;
  @apply shadow-xl;
}
</style>
